/* eslint-disable @typescript-eslint/camelcase */
import { injectable } from "tsyringe";
import { UserApiRepository } from "@/app/infrastructures/repositories/api/UserApiRepository";
import {
  UserEntities,
  UserDetailData,
  ReferenceEntities,
  RoleEntities,
  DivisionEntities,
  ShuttleEntities
} from "@/domain/entities/User";
import {
  EditUserRequestInterface,
  AddUserRequestInterface
} from "@/data/payload/contracts/UserRequest";
import {
  ResponsePayload,
  ResponsePayloadV2
} from "@/domain/entities/ResponsePayload";
import { RequestListUser } from "@/data/payload/api/UserApiRequest";

@injectable()
export class UserPresenter {
  private repository: UserApiRepository;

  constructor(repository: UserApiRepository) {
    this.repository = repository;
  }

  public getUserList(params: RequestListUser): Promise<UserEntities> {
    return this.repository.getUserList(params);
  }

  public getUserListV4(params: RequestListUser): Promise<UserEntities> {
    return this.repository.getUserListV4(params);
  }

  public getDetailUser(id: any): Promise<UserDetailData> {
    return this.repository.getDetailUser(id);
  }

  public editUser(payload: EditUserRequestInterface): Promise<ResponsePayload> {
    return this.repository.editUser(payload);
  }

  public getReference(
    account_type: any,
    search: string
  ): Promise<ReferenceEntities[]> {
    return this.repository.getReference(account_type, search);
  }

  public getDivision(search: string): Promise<DivisionEntities[]> {
    return this.repository.getDivision(search);
  }

   public getShuttle(search: string, hubId: number, partnerId: number ): Promise<ShuttleEntities[]> {
    return this.repository.getShuttle(search, hubId, partnerId);
  }

  public getRole(account_type: any): Promise<RoleEntities[]> {
    return this.repository.getRole(account_type);
  }

  public getRoleWithDivision(account_type: any, division_id: any): Promise<RoleEntities[]> {
    return this.repository.getRoleWithDivision(account_type, division_id);
  }

  public addUser(payload: AddUserRequestInterface): Promise<ResponsePayload> {
    return this.repository.addUser(payload);
  }

  public editRole(
    payload: EditUserRequestInterface
  ): Promise<ResponsePayloadV2> {
    return this.repository.editRole(payload);
  }

  public editAssigned3lc(
    payload: EditUserRequestInterface
  ): Promise<ResponsePayloadV2> {
    return this.repository.editAssigned3lc(payload);
  }
}
